import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Spin } from "antd"
import BatchesRows from "./BatchesRows"
import BatchRecycle from "../BatchRecycle"
import { DropdownMenu, DropdownToggle, UncontrolledDropdown, DropdownItem } from "reactstrap"

BatchesTable.propTypes = {
    loading: PropTypes.bool,
    batches: PropTypes.array,
    selectedBatchId: PropTypes.array,
    selectedAll: PropTypes.bool,
    onChangeProductType: PropTypes.func.isRequired,
    onSelectAll: PropTypes.func.isRequired,
    onResetSelected: PropTypes.func.isRequired
}

function BatchesTable(props) {
    const {
        loading,
        batches,
        selectedAll,
        selectedBatchId,
        onChangeProductType,
        onUpdateSelectedBatches,
        getItemColorSystemError,
        onResetSelected,
        handleChangeInput,
    } = props

    const [isOpen, setIsOpen] = useState(false)

    const _showModal = () => {
        setIsOpen(true)
    }

    const _closeModal = () => {
        setIsOpen(false)
    }

    function _handleChangeCheckbox(e) {
        const { checked } = e.target
        const { onSelectAll } = props

        if (typeof onSelectAll === 'function') {
            onSelectAll(checked)
        }
    }

    return (
        <div className='BatchesTable'>
            <Spin spinning={loading} tip='Đang tải...'>
                <table className='table table-borderless table-striped'>
                    <thead className={`thead-light ${selectedBatchId.length > 0 ? 'Hidden' : ''}`}>
                        <tr>
                            <th className="BatchSelectedAll">
                                <input type="checkbox" checked={selectedAll} onChange={_handleChangeCheckbox} />
                                {
                                    selectedBatchId.length > 0 &&
                                    <div className="CustomSelect">
                                        <th colSpan={13} className="position-relative">
                                            <UncontrolledDropdown className='MenuActions'>
                                                <DropdownToggle tag='span' className='ToggleActions'>
                                                    <span
                                                        className='border cursor-pointer rounded d-inline-flex px-2 py-1 bg-light font-weight-normal align-items-baseline'>
                                                        Thao tác <i className="fa fa-caret-down ml-2" />
                                                    </span>
                                                </DropdownToggle>

                                                <DropdownMenu>
                                                    <BatchRecycle
                                                        items={batches}
                                                        selectedBatchId={selectedBatchId}
                                                        getItemColorSystemError={getItemColorSystemError}
                                                        onResetSelected={onResetSelected}
                                                        onShowModal={_showModal}
                                                        onCloseModal={_closeModal}
                                                        isOpen={isOpen}
                                                    />
                                                </DropdownMenu>
                                            </UncontrolledDropdown>
                                        </th>
                                    </div>
                                }
                            </th>
                            <th className="barcode">Barcode</th>
                            <th className='sku'>SKU</th>
                            <th className="size">Size</th>
                            <th className="batch-name">Tên lô</th>
                            <th className="date-mark-error">Ngày đánh dấu lỗi</th>
                            <th className="error-style">Kiểu lỗi</th>
                            <th className="error-type">Loại lỗi</th>
                            <th className="error-detail">Chi tiết lỗi</th>
                            <th className="partner">Partner in ép</th>
                            <th className="user">Người tạo</th>
                            <th className="print">Máy in</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            !!batches && batches.length > 0 ? (
                                batches.map(item => {
                                    return (
                                        <BatchesRows
                                            key={item._id}
                                            item={item}
                                            selectedBatchId={selectedBatchId}
                                            onChangeProductType={onChangeProductType}
                                            onUpdateSelectedBatches={onUpdateSelectedBatches}
                                            handleChangeInput={handleChangeInput}
                                        />
                                    )
                                }
                                )
                            ) : (
                                <tr>
                                    <td colSpan={12}>Không có dữ liệu!</td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </Spin>
        </div>
    )
}

export default BatchesTable
